import { render, staticRenderFns } from "./ConnectedVoucherBadge.vue?vue&type=template&id=1c3e806f&scoped=true"
import script from "./ConnectedVoucherBadge.vue?vue&type=script&lang=js"
export * from "./ConnectedVoucherBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3e806f",
  null
  
)

export default component.exports